import { Col } from "antd";

export default function ColResponsiveDentro({children}) {
    return (
        <Col xs={24} sm={12} md={8} xl={6}>
            {children}
        </Col>
    )
}
